import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from "@ng-select/ng-select";
import { AiConfig } from './aiConfig';
import { AiConfigRoutingModule } from "./aiConfig-routing.module";
import { AiConfigService } from "../../../service/AiConfigService";
import { CourseService } from "../../../service/CourseService";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    AiConfigRoutingModule
  ],
  providers: [AiConfigService, CourseService],
  exports: [AiConfig],
  declarations: [AiConfig]
})
export class AiConfigModule {}
